import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryHotkeyIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 3.25H3C2.04 3.25 1.25 4.04 1.25 5V19C1.25 19.96 2.04 20.75 3 20.75H21C21.96 20.75 22.75 19.96 22.75 19V5C22.75 4.04 21.96 3.25 21 3.25ZM21.25 19C21.25 19.14 21.14 19.25 21 19.25H3C2.86 19.25 2.75 19.14 2.75 19V5C2.75 4.86 2.86 4.75 3 4.75H21C21.14 4.75 21.25 4.86 21.25 5V19Z"
        fill={color}
      />
      <path
        d="M6.38 7H5.62C5.27758 7 5 7.27758 5 7.62V8.38C5 8.72242 5.27758 9 5.62 9H6.38C6.72242 9 7 8.72242 7 8.38V7.62C7 7.27758 6.72242 7 6.38 7Z"
        fill={color}
      />
      <path
        d="M10.38 7H9.62C9.27758 7 9 7.27758 9 7.62V8.38C9 8.72242 9.27758 9 9.62 9H10.38C10.7224 9 11 8.72242 11 8.38V7.62C11 7.27758 10.7224 7 10.38 7Z"
        fill={color}
      />
      <path
        d="M14.38 7H13.62C13.2776 7 13 7.27758 13 7.62V8.38C13 8.72242 13.2776 9 13.62 9H14.38C14.7224 9 15 8.72242 15 8.38V7.62C15 7.27758 14.7224 7 14.38 7Z"
        fill={color}
      />
      <path
        d="M18.38 7H17.62C17.2776 7 17 7.27758 17 7.62V8.38C17 8.72242 17.2776 9 17.62 9H18.38C18.7224 9 19 8.72242 19 8.38V7.62C19 7.27758 18.7224 7 18.38 7Z"
        fill={color}
      />
      <path
        d="M6.38 11H5.62C5.27758 11 5 11.2776 5 11.62V12.38C5 12.7224 5.27758 13 5.62 13H6.38C6.72242 13 7 12.7224 7 12.38V11.62C7 11.2776 6.72242 11 6.38 11Z"
        fill={color}
      />
      <path
        d="M10.38 11H9.62C9.27758 11 9 11.2776 9 11.62V12.38C9 12.7224 9.27758 13 9.62 13H10.38C10.7224 13 11 12.7224 11 12.38V11.62C11 11.2776 10.7224 11 10.38 11Z"
        fill={color}
      />
      <path
        d="M14.38 11H13.62C13.2776 11 13 11.2776 13 11.62V12.38C13 12.7224 13.2776 13 13.62 13H14.38C14.7224 13 15 12.7224 15 12.38V11.62C15 11.2776 14.7224 11 14.38 11Z"
        fill={color}
      />
      <path
        d="M15.38 15H8.62C8.27758 15 8 15.2776 8 15.62V16.38C8 16.7224 8.27758 17 8.62 17H15.38C15.7224 17 16 16.7224 16 16.38V15.62C16 15.2776 15.7224 15 15.38 15Z"
        fill={color}
      />
      <path
        d="M18.38 11H17.62C17.2776 11 17 11.2776 17 11.62V12.38C17 12.7224 17.2776 13 17.62 13H18.38C18.7224 13 19 12.7224 19 12.38V11.62C19 11.2776 18.7224 11 18.38 11Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryHotkeyIcon.displayName = 'LibraryHotkeyIcon';
